import { BePlannedGridPage } from "./BePlannedGrid";
export default BePlannedGridPage;
